const arrowKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];

export function findGridNeighbor(
  layout: Map<string, { row: number; col: number }>,
  currentId: string,
  key: string
) {
  if (!arrowKeys.includes(key)) return null;

  const curr = layout.get(currentId);
  if (!curr) return null;

  const entries = [...layout.entries()];
  const fixedAxis = ["ArrowLeft", "ArrowRight"].includes(key) ? "row" : "col";
  const moveAxis = fixedAxis === "row" ? "col" : "row";
  const ascending = ["ArrowRight", "ArrowDown"].includes(key);

  const inDirection = entries.filter(([, p]) =>
    ascending ? p[moveAxis] > curr[moveAxis] : p[moveAxis] < curr[moveAxis]
  );

  const sameAxis = inDirection.filter(
    ([, p]) => p[fixedAxis] === curr[fixedAxis]
  );
  if (sameAxis.length > 0) {
    sameAxis.sort((a, b) =>
      ascending
        ? a[1][moveAxis] - b[1][moveAxis]
        : b[1][moveAxis] - a[1][moveAxis]
    );
    return sameAxis[0]?.[0];
  }

  // Nothing shares the fixed axis (sparse grids leave dead ends), so fall
  // back to the nearest step in the pressed direction: closest along the
  // move axis first, then the smallest sideways drift.
  inDirection.sort((a, b) => {
    const mainA = Math.abs(a[1][moveAxis] - curr[moveAxis]);
    const mainB = Math.abs(b[1][moveAxis] - curr[moveAxis]);
    if (mainA !== mainB) return mainA - mainB;
    const driftA = Math.abs(a[1][fixedAxis] - curr[fixedAxis]);
    const driftB = Math.abs(b[1][fixedAxis] - curr[fixedAxis]);
    if (driftA !== driftB) return driftA - driftB;
    return a[1][fixedAxis] - b[1][fixedAxis];
  });

  return inDirection[0]?.[0];
}
